// extracted by mini-css-extract-plugin
module.exports = {"failedOrder":"PlaceOrderDegradedMessage__failedOrder___2wZRF","failedCall":"PlaceOrderDegradedMessage__failedCall___13Kk8"};